
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
  font-family: var(--ff-display);
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* unset browser defaults for headings and p */
:host:is(h1,h2,h3,h4,h5,h6,p),
h1,h2,h3,h4,h5,h6 {
  all: unset;
}
/* Image reset */
img {
  max-width: 100%;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.sr-only,
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.annuities-distributors-hero-wrapper{
  height:100%;
  display:flex;
  flex-direction:column;
  align-items:var(--sic-annuities-content-alignment-mobile);
  text-align:left;
  row-gap:var(--spacing-08);
  color:var(--sic-text-color);
}

  @media (min-width: 1024px){.annuities-distributors-hero-wrapper{
    flex-direction:row;
    display:flex;
    justify-content:flex-start;
    align-items:var(--sic-annuities-content-alignment);
    gap:10%
}
  }

  @media (min-width: 1380px){.annuities-distributors-hero-wrapper{
    gap:15%
}
  }

.text-wrapper{
  display:flex;
  justify-content:center;
  align-items:flex-start;
  flex-direction:column;
  padding:0px;
  row-gap:var(--spacing-08);
  width:100%;
  max-width:528px;
}

@media (min-width: 1024px){

.text-wrapper{
    width:45%
}
  }

.drop-down-wrapper{
  display:flex;
  flex-direction:column;
  align-items:flex-start;
  padding:0px;
  row-gap:var(--spacing-02);
  width:100%;
}

@media (min-width: 1024px){

.drop-down-wrapper{
    max-width:528px
}
  }

.cta-menu-wrapper{
  width:100%;
  display:flex;
  flex-direction:column;
  align-items:flex-start;
  row-gap:var(--spacing-06);
}

@media (min-width: 1024px){

.cta-menu-wrapper{
    width:50%;
    min-width:40%
}
  }

@media (min-width: 1380px){

.cta-menu-wrapper{
    min-width:30%
}
  }
`;